export default __webpack_public_path__ + "static/media/social-youtube.abcf4fb1.svg";